import Ajv from "ajv";

const DJANGO_ERROR_SCHEMA = {
  type: "object",
  properties: {
    type: { type: "string", const: "validation_error" },
    errors: {
      type: "array",
      items: {
        type: "object",
        properties: {
          code: { type: "string" },
          detail: { type: "string" },
          attr: { type: "string" },
        },
        required: ["code", "detail", "attr"],
        additionalProperties: false,
      },
      minItems: 1,
    },
  },
  required: ["type", "errors"],
  additionalProperties: false,
};

type DjangoError = {
  type: "validation_error";
  errors: {
    code: string;
    detail: string;
    attr: string;
  }[];
};

/**
 * Type guard to check if an object is formatted as a Django error.
 * @param obj The object to check.
 * @returns `true` if the object is a Django error, `false` otherwise.
 */
export const isDjangoError = new Ajv({
  strict: false,
}).compile<DjangoError>(DJANGO_ERROR_SCHEMA);
